import { useState } from "react";
import DashboardLayout from "components/layout/DashboardLayout";
import DashboardNavbar from "components/navigation/DashboardNavbar";
import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";
import { Card, Tab, Tabs } from "@mui/material";
import {
  IoBusinessOutline,
  IoPeople,
  IoShieldCheckmark,
  IoPulse,
  IoStatsChart,
  IoFootsteps,
  IoGitNetworkOutline,
} from "react-icons/io5";

import ClientManagement from "./components/ClientManagement";
import UserManagement from "./components/UserManagement";
import ProductReview from "./components/ProductReview";
import SystemMonitor from "./components/SystemMonitor";
import TokenUsage from "./components/TokenUsage";
import UserActivity from "./components/UserActivity";
import KolProfiles from "./components/KolProfiles";

// Tab indices
const TAB_CLIENTS        = 0;
const TAB_USERS          = 1;
const TAB_KOL_PROFILES   = 2;
const TAB_PRODUCT_REVIEW = 3;
const TAB_SYSTEM         = 4;
const TAB_TOKEN_USAGE    = 5;
const TAB_USER_ACTIVITY  = 6;

function AdminPage() {
  const [activeTab, setActiveTab] = useState(TAB_CLIENTS);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox>
        <VuiBox mb={2}>
          <VuiTypography variant="h3" color="white">
            Admin Panel
          </VuiTypography>
          <VuiTypography variant="body2" color="text">
            System configuration and maintenance operations.
          </VuiTypography>
        </VuiBox>

        <Card>
          <VuiBox>
            <Tabs
              value={activeTab}
              onChange={(_, v) => setActiveTab(v)}
              sx={{ background: "transparent" }}
            >
              <Tab
                label="Clients"
                icon={<IoBusinessOutline size="16px" />}
                iconPosition="start"
                sx={{ pl: 1 }}
              />
              <Tab
                label="Users"
                icon={<IoPeople size="18px" />}
                iconPosition="start"
                sx={{ pl: 1 }}
              />
              <Tab
                label="KOL Profiles"
                icon={<IoGitNetworkOutline size="16px" />}
                iconPosition="start"
                sx={{ pl: 1 }}
              />
              <Tab
                label="Product Review"
                icon={<IoShieldCheckmark size="16px" />}
                iconPosition="start"
                sx={{ pl: 1 }}
              />
              <Tab
                label="System Monitor"
                icon={<IoPulse size="16px" />}
                iconPosition="start"
                sx={{ pl: 1 }}
              />
              <Tab
                label="Token Usage"
                icon={<IoStatsChart size="16px" />}
                iconPosition="start"
                sx={{ pl: 1 }}
              />
              <Tab
                label="User Activity"
                icon={<IoFootsteps size="16px" />}
                iconPosition="start"
                sx={{ pl: 1 }}
              />
            </Tabs>
          </VuiBox>

          <VuiBox p={2}>
            {activeTab === TAB_CLIENTS        && <ClientManagement />}
            {activeTab === TAB_USERS          && <UserManagement />}
            {activeTab === TAB_KOL_PROFILES   && <KolProfiles />}
            {activeTab === TAB_PRODUCT_REVIEW && <ProductReview />}
            {activeTab === TAB_SYSTEM         && <SystemMonitor />}
            {activeTab === TAB_TOKEN_USAGE    && <TokenUsage />}
            {activeTab === TAB_USER_ACTIVITY  && <UserActivity />}
          </VuiBox>
        </Card>
      </VuiBox>
    </DashboardLayout>
  );
}

export default AdminPage;
